<s1-input-label [label]="label" [grouped]="labelGrouped">
  @if (!readonly) {
    <input class="form-control" [ngClass]="{'is-invalid' : !checkIsValid() }" type="text" bsDatepicker [bsConfig]="bsConfig" [minDate]="minDate" [formControl]="control" [readonly]="readonly" />
  }
  @if (readonly) {
    <input class="form-control" type="text" [value]="readableDate()" [readonly]="true" />
  }
</s1-input-label>